import { TbCheck, TbQuestionMark } from 'react-icons/tb'
import { Heading, Text } from 'ui-kit/typography'
import { Link } from 'ui-kit/actions/link/Link'
import { Tooltip } from 'routes/components/Shared/Tooltip'
import { pricingPlansData, PricingPlansDataType } from './pricingPlansData'
import classes from './PricingPlans.module.scss'

export function PricingPlans() {
  const customerLogoStyles = (multiplier: number, amount: number) => {
    return {
      left: multiplier * 34,
      zIndex: amount - multiplier,
    }
  }
  return (
    <ul className={classes.list}>
      {pricingPlansData.map(
        ({ title, features, customers }: PricingPlansDataType) => (
          <li className={classes.item} key={title}>
            <header className={classes.header}>
              <Heading as={'h3'}>{title}</Heading>
            </header>

            <main className={classes.content}>
              <ul className={classes.listFeatures}>
                {features.map(({ title, tooltip }) => (
                  <li key={title} className={classes.itemFeatures}>
                    {tooltip ? (
                      <>
                        <TbCheck className={classes.icon__check} />
                        <span>
                          {title}&nbsp;
                          <Tooltip tooltip={tooltip}>
                            <span className={classes.icon__tooltip}>
                              <TbQuestionMark />
                            </span>
                          </Tooltip>
                        </span>
                      </>
                    ) : (
                      <>
                        <TbCheck className={classes.icon__check} />
                        {title}
                      </>
                    )}
                  </li>
                ))}
              </ul>
            </main>
            <footer className={classes.footer}>
              <Text as={'span'} lh={'tight'}>
                Trusted by:
              </Text>
              <ul>
                {customers.map(
                  ({ name, logo, width, height, url, tooltip }, idx) => (
                    <li
                      key={name}
                      style={customerLogoStyles(idx, customers.length)}
                    >
                      <Link href={url} target='_blank' className={classes.link}>
                        <img
                          src={logo.src}
                          alt={name}
                          width={width}
                          height={height}
                        />
                      </Link>
                      <div className={classes.tooltip}>
                        <span className={classes.tooltipHeading}>{name}</span>
                        <span className={classes.tooltipDesc}>{tooltip}</span>
                      </div>
                    </li>
                  ),
                )}
              </ul>
            </footer>
          </li>
        ),
      )}
    </ul>
  )
}
